import { axiosPublic, axiosPrivate } from "../utils";
import { toast } from 'react-toastify';

export const editProfile = async (data) => {
    const { firstname, lastname } = data;
    console.log(data)
    try {
        const res = await axiosPrivate.post('auth/profile', {
            firstName: firstname,
            lastName: lastname
        });
        if (!res.data.result) {
            if (res.data.message) {
                toast.error(res.data.message);
            }
            console.log(res.data);
            return res.data.message;
        }
        toast.success(res.data.message);

        return res.data.result;
    } catch (error) {
        console.log(error);
        if (error?.response?.data?.message) {
            toast.error(error.response.data.message);
        }
        return error.response.data.result;
    }
}
